export const arrayToTagCategory = (array = []) => {
  return {
    id: 'status',
    description: 'Status',
    internal_name: 'status',
    label: 'Status',
    tags: array.map((item) => ({
      category_id: item.value,
      description: item.label,
      label: item.label,
      internal_name: item.value,
      external_key: item.value,
      id: item.value,
      local_parent_id: 'status',
      parent_id: 'status',
    })),
  };
};

export const getSectionsFilterConfig = (array = []) => {
  return {
    id: 'section',
    description: 'Class',
    internal_name: 'section',
    label: 'Class',
    tags: array.map((item) => ({
      category_id: item.value,
      description: item.label,
      label: item.label,
      internal_name: item.value,
      external_key: item.value,
      id: item.value,
      local_parent_id: 'section',
      parent_id: 'section',
    })),
  };
};
